import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentService } from '@app/environment.service';
import { Observable, map } from 'rxjs';


export interface ArticleAuthor {
  _id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

export interface ArticleCategory {
  _id: string;
  name: string;
  slug: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

export interface ImageFormat {
  name: string;
  hash: string;
  ext: string;
  mime: string;
  width: number;
  height: number;
  size: number;
  path: string | null;
  url: string;
}

export interface ArticleImage {
  _id: string;
  name: string;
  alternativeText: string;
  caption: string;
  hash: string;
  ext: string;
  mime: string;
  size: string;
  width: number;
  height: number;
  url: string;
  formats: { [key: string]: ImageFormat};
  provider: string;
  related: string[];
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

export interface Article {
    _id:  string;
    title: string;
    content: string;
    slug: string;
    description: string;
    published_at: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    author: ArticleAuthor;
    category: ArticleCategory;
    image: string;
    id: string
}

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(private http: HttpClient, private environment: EnvironmentService) {}

  public getArticles(): Observable<any> {
    return this.http.get(`${this.environment.strapiUrl}/articles`, { headers: { 'x-ignore-device-interceptor': '1' }});
  }

  public getFeaturedArticle() {
    return this.http.get<Article[]>(`${this.environment.strapiUrl}/articles?category.name=Featured`, { headers: { 'x-ignore-device-interceptor': '1' }})
      .pipe(
        map(resp => resp[0]),
      );
  }

  public getNewsArticles() {
    return this.http.get<Article[]>(`${this.environment.strapiUrl}/articles?category.name=News`, { headers: { 'x-ignore-device-interceptor': '1' }})
  }

  public getDestinationArticles() {
    return this.http.get<Article[]>(`${this.environment.strapiUrl}/articles?category.name=Destinations`, { headers: { 'x-ignore-device-interceptor': '1' }})
  }

  getArticle(slug: string) {
    return this.http.get<Article>(`${this.environment.strapiUrl}/articles/${slug}`, { headers: { 'x-ignore-device-interceptor': '1' }});
  }
}
